import { Map } from "@/components/Map";
import { DateRangeNavigator } from "./components/DateRangeNavigator";
// import "./style.css";
import "./out.css";

export function Main() {
  return (
    <>
      <Map />
      <DateRangeNavigator />
    </>
  );
}
